import SignUpCustomerSFC from "./SignUpCustomer.vue";
export type { ISignUpCustomerEmits } from "./emits";
export type { ISignUpCustomerProps } from "./props";
export const SignUpCustomer = SignUpCustomerSFC;
